import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { Globe, User } from 'lucide-react';

export type SearchMode = 'local' | 'global';

interface SearchContextToggleProps {
  mode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
  contextLabel?: string;
  disabled?: boolean;
}

export function SearchContextToggle({
  mode,
  onModeChange,
  contextLabel,
  disabled,
}: SearchContextToggleProps) {
  // Don't render if there's no context to toggle (always global)
  if (!contextLabel) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b border-border">
      <span className="text-xs text-muted-foreground">Search in:</span>
      <ToggleGroup
        type="single"
        value={mode}
        onValueChange={(value) => {
          if (value) onModeChange(value as SearchMode);
        }}
        disabled={disabled}
        size="sm"
        className="gap-1"
      >
        <ToggleGroupItem
          value="local"
          className="text-xs px-2 h-7 gap-1"
          disabled={!contextLabel}
        >
          <User className="h-3 w-3" />
          {contextLabel}
        </ToggleGroupItem>
        <ToggleGroupItem
          value="global"
          className="text-xs px-2 h-7 gap-1"
        >
          <Globe className="h-3 w-3" />
          Everywhere
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
